import { apiFetch } from './client';

export interface HelpManifestEntry { id: string; title: string }
export interface HelpManifestSet { key: string; topics: HelpManifestEntry[] }
export interface HelpManifest { sets: HelpManifestSet[] }
export interface HelpTopic { id: string; locale: string; title: string; bodyMarkdown: string; origin: string }

export function getHelpManifest(token: string, locale: string): Promise<HelpManifest> {
  return apiFetch<HelpManifest>(`/v1/book/${encodeURIComponent(token)}/help/manifest?locale=${locale}`);
}

export function getHelpTopic(token: string, topicId: string, locale: string): Promise<HelpTopic> {
  return apiFetch<HelpTopic>(`/v1/book/${encodeURIComponent(token)}/help/topics/${topicId}?locale=${locale}`);
}
